import { useEffect, useRef, useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import styled from 'styled-components';

import { navMobileList, navbarSublists } from '../../../config/globalHeaderData';
import { DropdownContext } from '../../../store/navbar-dropdown-context';

const Nav = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: -0.1px 6px 9px -6px rgba(0, 0, 0, 0.5);
  z-index: 1100;
  position: relative;

  .dropdownContainer {
    // outline: none;
    // visibility: hidden;
    // opacity: 0;
    margin: 0 auto;
    position: relative;
    width: 1400px;
  }

  .invisible {
    visibility: hidden;
  }
`;

const NavContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  text-align: left;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

const UlContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 1rem 0 0 0.75rem;
`;

const LiSection = styled.li`
  display: inline-block;
  position: relative;
  line-height: 50px;
  letter-spacing: 1px;
  text-align: center;
  transition:all 0.3s ease-in-out;

  a {
    color: #585C65;
    text-decoration: none;
  }

  .navTitle {
    display: block;
    color: #585C65;
    font-family: poppins;
    font-size: 17px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: normal;
    text-decoration: none;
    // margin: 0 45px 0 5px;
    padding: 0 1rem;
    user-select:none;
    border-top: 4px solid transparent;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }

  .navTitle:hover {
    cursor: pointer;
  }

  .navText {
    border-bottom: 4px solid transparent;
  }

  .navText:hover {
    cursor: pointer;
    color: #3A75BD;
    border-bottom: 4px solid #3A75BD;

    ::after {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-bottom: 1px solid #298085;
      border-left: 1px solid #298085;
      margin: 0 0 4px 8px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }

  .navText::after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-bottom: 1px solid #585C65;
    border-left: 1px solid #585C65;
    margin: 0 0 4px 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .clicked {
    color: #FFFFFF;
    background: #004971;
  }

  .clicked::after {
    border-top: 1px solid #FFFFFF;
    border-right: 1px solid #FFFFFF;
    border-bottom: 0;
    border-left: 0;
    margin: 0 0 0 8px
  }

  .clicked:hover {
    border-bottom: 4px solid #004971;
    color: #FFFFFF;

    ::after {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-top: 1px solid #FFFFFF;
      border-right: 1px solid #FFFFFF;
      border-bottom: 0;
      border-left: 0;
      margin: 0 0 0 8px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }

  .directLink::after {
    display: none;
  }

  .directLink:hover {
    ::after {
      display: none;
    }
  }

  .shouldBeUnderlined {
    border-bottom: 4px solid #3A75BD;
  }

  .navTitleClicked {
    display: block;
    color: #FFFFFF;
    font-family: poppins;
    font-size: 17px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: normal;
    text-decoration: none;
    // margin: 0 45px 0 5px;
    padding: 0 1rem;
    user-select:none;
    background: #004971;
    border-top: 4px solid #5786FF;
    border-left: 4px solid #5786FF;
    border-right: 4px solid #5786FF;
  }
`;

const Dropdown = styled.div`
  top: 60.5px;
  left: 0;
  width: 100%;
  background: #004971;
  z-index: 1100;
  position: absolute;
  // visibility: hidden;
  // outline: none;
  // opacity: 0;
`;

const DropdownContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  padding: 20px 0 40px 0;
  background: #004971;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 10px;

  .dropdownList {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    gap: 50px;
    padding: 15px 32px 15px 2rem;
  }

  .dropdownRow {
    display: flex;
    align-items: center;
    gap: 120px;
  }

  .dropdownItem {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 250px;
    font-family: 'Poppins';
    font-weight: 600;
    font-style: normal;
    font-size: 20px;
    line-height: 110%;
    color: #FFFFFF;
    text-decoration: none;
  }

  .dropdownItem:hover {
    text-decoration: underline;
  }

  .dropdownItemText {
    margin-top: 5px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16.16px;
    line-height: 22px;
  }
`;

const StyledLoginLink = styled(Link)`
  color: #007BBD;
  text-align: right;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.42px;
  text-decoration: none;
  text-transform: uppercase;
  padding: 10px 0 10px 0;
  margin-bottom: 4.5px;
  margin-right: 32px;
`;

const useOutsideAlerter = (ref) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target ||
        (event.target.getAttribute("class") !== "dropdownList" && ref.current && !ref.current.contains(event.target))
      ) {
        const toggle = document.getElementsByClassName("navText clicked");
        if (toggle[0] && !event.target.getAttribute("class")?.includes("navText clicked")) {
          const temp: HTMLElement = toggle[0] as HTMLElement;
          temp.click();
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

const NavBar = () => {
  const { clickedTitle, setClickedTitle } = useContext(DropdownContext);
  const dropdownSelection = useRef(null);
  // Exclude Login from Navbar
  // const filteredNavMobileList = navMobileList.filter((item) => !item.notExistInNav);
  const clickableObject = navMobileList.filter((item) => item.className === 'navMobileItem clickable');
  const clickableTitle = clickableObject.map((item) => item.name);
  useOutsideAlerter(dropdownSelection);

  const handleMenuClick = (e) => {
    if (e.target.innerText === clickedTitle || !clickableTitle?.includes(e.target.innerText)) {
      setClickedTitle("");
    } else {
      setClickedTitle(e.target.innerText);
    }
  };

  const onKeyPressHandler = (e) => {
    if (e.key === "Enter") {
      handleMenuClick(e);
    } else if (e.key === 'Escape') {
      setClickedTitle("");
    }
  };

  type NavSubLinkData = {
    name: string;
    link: string;
    className: string;
  };

  function shouldBeUnderlined(item) {
    const linkName = item.name;
    const correctPath = window.location.href.slice(window.location.href.lastIndexOf(window.location.host) + window.location.host.length);
    if (item.className === "navMobileItem") {
      return correctPath === item.link;
    }
    if (navbarSublists[linkName] === undefined) {
      return false;
    }
    const linkNames = Object.values(navbarSublists[linkName]).map((e: NavSubLinkData) => e.link);
    return linkNames.includes(correctPath);
  }

  useEffect(() => {
    setClickedTitle("");
  }, []);

  return (
    <Nav>
      <NavContainer>
        <UlContainer>
          {
            navMobileList.map((navMobileItem, idx) => {
              const navkey = `nav_${idx}`;
              return (
                navMobileItem.className === 'navMobileItem'
                  ? (
                    <LiSection key={navkey}>
                      <div className="navTitle directLink">
                        <NavLink
                          to={navMobileItem.link}
                          reloadDocument={navMobileItem.reloadDocument}
                          target={navMobileItem.external ? "_blank" : null}
                          rel={navMobileItem.external ? "noopener noreferrer" : null}
                        >
                          <div
                            id={navMobileItem.id}
                            onKeyDown={onKeyPressHandler}
                            role="button"
                            tabIndex={0}
                            className={`navText directLink ${shouldBeUnderlined(navMobileItem) ? "shouldBeUnderlined" : ""}`}
                            onClick={handleMenuClick}
                          >
                            {navMobileItem.name}
                          </div>
                        </NavLink>
                      </div>
                    </LiSection>
                  )
                  : (
                    <LiSection key={navkey}>
                      <div className={clickedTitle === navMobileItem.name ? 'navTitleClicked' : 'navTitle'}>
                        <div
                          id={navMobileItem.id}
                          onKeyDown={onKeyPressHandler}
                          role="button"
                          tabIndex={0}
                          className={`${clickedTitle === navMobileItem.name ? 'navText clicked' : 'navText'} ${shouldBeUnderlined(navMobileItem) ? "shouldBeUnderlined" : ""}`}
                          onClick={handleMenuClick}
                        >
                          {navMobileItem.name}
                        </div>
                      </div>
                    </LiSection>
                  )
              );
            })
          }
        </UlContainer>
        {/* <StyledLoginLink id="header-navbar-login-button" to="/login">
          Login
        </StyledLoginLink> */}
      </NavContainer>
      <Dropdown ref={dropdownSelection} className={clickedTitle === '' ? "invisible" : ""}>
        <DropdownContainer>
          <div className="dropdownList">
            <div className="dropdownRow">
              {
                clickedTitle !== "" && navbarSublists[clickedTitle].slice(0, 3).map((dropItem, idx) => {
                  const dropkey = `drop_${idx}`;
                  return (
                    dropItem.link && (
                      <Link
                        id={dropItem.id}
                        to={dropItem.link}
                        target={dropItem.external ? "_blank" : null}
                        rel={dropItem.external ? "noopener noreferrer" : null}
                        className="dropdownItem"
                        key={dropkey}
                        onClick={() => setClickedTitle("")}
                      >
                        {dropItem.name}
                        <div className="dropdownItemText">{dropItem.text}</div>
                      </Link>
                    )
                  );
                })
              }
            </div>
            <div className="dropdownRow">
              {/* For alignment purposes only */}
              <div className="dropdownItem"></div>
              {
                clickedTitle !== "" && navbarSublists[clickedTitle].slice(3).map((dropItem, idx) => {
                  const dropkey = `drop_${idx + 3}`;
                  return (
                    dropItem.link && (
                      <Link
                        id={dropItem.id}
                        to={dropItem.link}
                        target={dropItem.external ? "_blank" : null}
                        rel={dropItem.external ? "noopener noreferrer" : null}
                        className="dropdownItem"
                        key={dropkey}
                        onClick={() => setClickedTitle("")}
                      >
                        {dropItem.name}
                        <div className="dropdownItemText">{dropItem.text}</div>
                      </Link>
                    )
                  );
                })
              }
            </div>
          </div>
        </DropdownContainer>
      </Dropdown>
    </Nav>
  );
};

export default NavBar;
